<script setup lang="ts">
import { i18n } from '@/i18n';
import { TableContentItem } from '../../interface/tableContentItems';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { useEditIndividualBusinessStore } from '@/editBusinessModule/pages/useEditIndividualBusinessStore';
import { storeToRefs } from 'pinia';

const props = defineProps<{
  item: TableContentItem;
}>();

const t = i18n.t;

const store = useEditIndividualBusinessStore();
const { state } = storeToRefs(store);

/**
 * ボタンクリック時の処理
 */
const onClick = () => {
  store.setEditingBusiness(props.item);
  store.openEditModal();
};
</script>
<template>
  <TextButton button-style="btn-secondary" @click="onClick">
    {{ t('編集') }}
  </TextButton>
</template>
<style lang="scss" scoped></style>
